<template>
  <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Profile</strong> Form
          </div>
          
          <BlockUI message="loading" v-if="isLoading">
            <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
          </BlockUI>
          <b-alert show  :variant="msg_type" v-if="msg">{{msg}}</b-alert>
          <b-form v-on:submit.prevent="saveForm()">
            <b-form-group
              label="Email"
              label-for="horizEmail"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="horizEmail" type="email" placeholder="Enter Email.." autocomplete="username email" required class="form-control-warning" v-model="user.email" readonly></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Name"
              label-for="name"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="name" type="text" placeholder="Enter name.." autocomplete="name" required class="form-control-warning" v-model="user.full_name" readonly></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Password"
              label-for="password"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="password" type="password" placeholder="Enter password.." autocomplete="password" :required="id===undefined ? true : false" class="form-control-warning" v-model="user.password"></b-form-input>              
            </b-form-group>
            

            <div class="form-group">
              <div class="form-row">
                <label id="__BVID__244__BV_label_" for="password" class="col-sm-3 col-form-label"></label>
                <div class="col-sm-9">              
                  <b-progress :value="uploadPercentage" :max="100" show-progress animated  v-if="!image"></b-progress>
                  <img :src="image" class="" style="width:100px"  v-if="image" />
                </div>
              </div>
            </div>
            
            <div slot="footer">
              <div class="form-row">
                <div class="col-sm-3">
                  
                </div>
                <div class="col-sm-9">
                  <b-button type="submit" size="sm" variant="primary" :disabled="isLoading" > Submit</b-button>
                  <b-button type="button" @click="goBack" size="sm" variant="danger" :disabled="isLoading">Back</b-button>
                </div>
              </div>

            </div>
          </b-form>
        </b-card>
      </b-col>
  </b-row>
</template>

<script>
//import usersData from './UsersData'
import { VueEditor } from 'vue2-editor'
export default {
  name: 'Profile',
  components: {
      VueEditor
   },
  props: {
    caption: {
      type: String,
      default: 'User '
    },
  },
  
  mounted() {
      this.getData();
    
  },
  data: () => {
    return {
      error: false,
      user: {
        full_name:'',
        email:'',
        password:''
      },
      image:'',
      file:'',
      uploadPercentage :0,
      msg : '',
      id:'',
      msg_type : '',
      isLoading:false,
    }
    
  },
  methods: {
    getData(){
      var app = this;
      this.user = JSON.parse(window.sessionStorage.getItem(this.setting.user_local_));
    },
    saveForm() {
      var app = this;
      var newDt = app.user;
      var url = this.end_point;
      
      
        url += 'users/'+this.user.id;
      
      app.isLoading=true;
      axios.put(url, newDt)
      .then(function (resp) {
          app.isLoading=false;
        if(resp.data.error){
          app.msg = resp.data.msg;
          app.error = resp.data.error;
          app.msg_type = 'danger';
          window.scrollTo(0,0);
        }else{
          app.error = false;
          app.msg_type = 'info';
          app.msg = resp.data.msg;
          let auth = window.sessionStorage.getItem(app.setting.user_local_);
          auth = JSON.parse(auth);
          auth.name = newDt.name;
          auth.email = newDt.email;
          if(newDt.new_file){
            auth.photo = resp.data.photo;
            
            let pp = document.body.querySelector('#pp-img');
            pp.setAttribute('src',auth.photo);
          }
            let pp = document.body.querySelector('#pp-label');
            pp.innerHTML=auth.name;
          window.sessionStorage.setItem(app.setting.user_local_,JSON.stringify(auth));    
          window.scrollTo(0,0);
          //app.$router.replace(`/users?msg=${app.msg}&msg_type=${app.msg_type}`);
        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.msg = 'could not save';
        app.msg_type = 'danger';
        app.error = true;
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    submitFile(){
      let formData = new FormData();
      formData.append('file', this.file);
      var app  = this;
      app.isLoading=true;
      axios.post( this.end_point+'users/upload',formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function( progressEvent ) {
          this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
        }.bind(this)
      }).then(function(e){
        
        app.isLoading=false;
        //console.log(e);
        if(e.data.error){
          app.msg = e.data.msg;
          app.msg_type = 'danger';
          return false;
        }
        app.msg='';
        app.user.new_file = e.data.file_path;       
        app.createImage(app.file);
      })
      .catch(function(e){
          app.isLoading=false;
          app.msg = 'upload filed please try again';
          app.msg_type = 'danger';
      });
    },
    onFileChange(e){
      this.image= '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){      
          return;
      }
      this.file = files[0];
      this.submitFile();
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  }
}
</script>
